<template>
<div class="cardddd mt-5">
    <h5 class="mb-3">Competitions Global Settings</h5>

    <div class="row">
        <div class="col-md-8">
            <b>Default Values</b>
            <p class="text-secondar">Set default values for fields</p>
        </div>
        <div class="col-md-4">
            <a href="#" class="btn btn-outline-dark btn-lg">Edit</a>
        </div>
    </div>
    <div class="divider2"></div>
    <div class="row">
        <div class="col-md-8">
            <b>Competition Types</b>
            <p class="text-secondar">Available Competition Types</p>
        </div>
        <div class="col-md-4">
            <a href="#" class="btn btn-outline-dark btn-lg">Edit</a>
        </div>
    </div>
    <div class="divider2"></div>
    <div class="row">
        <div class="col-md-8">
            <b>Competition Themes</b>
            <p class="text-secondar">Available Competition Themes</p>
        </div>
        <div class="col-md-4">
            <a href="#" class="btn btn-outline-dark btn-lg">Edit</a>
        </div>
    </div>
    <div class="divider2"></div>
    <div class="row">
        <div class="col-md-8">
            <b>Competition Categories</b>
            <p class="text-secondar">Available Competition Categories</p>
        </div>
        <div class="col-md-4">
            <a href="#" class="btn btn-outline-dark btn-lg">Edit</a>
        </div>
    </div>
    <div class="button-group">
        <button class="btn btn-sm" id="view">View All</button>
        <button class="btn btn-sm" id="new">Add New</button>
    </div>
</div>
</template>

<script>
export default {
    name: "GlobalSettings",
};
</script>

<style scoped></style>
